import React, { useContext } from 'react';
import Button from '../Button';
import langs from '../../translations/langs';
import { GlobalContext } from '../../reducers/global';

const Back = ({ onClick }) => {
    const {
        state: { options },
    } = useContext(GlobalContext);

    const { back } = langs[options.language];

    return (
        <>
            <div className="back">
                <Button text={back} buttonStyle="txt" onClick={onClick} />
            </div>
        </>
    );
};

export default Back;
